<template>
    <div class="page-content">
        <div id="privacy" class="section grow pt-5 pb-5 bg-eggshell">
            <div class="container h-100">
                <div class="d-flex h-100 text-left align-items-center">
                    <div class="w-100">
                        <termly-policy termlyDataId="b10e1028-1be1-4b96-9925-0fd1c51ddffa"></termly-policy>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'privacy',
  metaInfo: {
      title: 'Privacy Policy'
  },
  components: {
  }
}
</script>
